import React, { Component } from "react"
import { Drawer, Row, message, Typography, Select } from "antd"
import { Form } from '@ant-design/compatible';

import DadosPessoais from "./DadosPessoais"
import SubmitButton from "../../../shared/components/submit/SubmitButton"

import {
  post,
  update,
  find
} from "../../../shared/services/http/UsuarioService"

import "./UsuarioFormulario.scss"
import {withAppInsightsTracking} from "../../../shared/services/AppInsightsService";
import { MenuFuncionarioEnum } from "../../../shared/Enum/MenuFuncionarioEnum"

class UsuarioFormulario extends Component {
  constructor(props) {
    super(props)

    this.state = {
      selectedMenusChanged: false,
      selectedMenus: [],
      loading: false,
      loadingApproveRegister: false,
      user: this.props.user,
    }
    this.dadosPessoais = React.createRef()
  }

  beforeClose = (user) => {
    this.setState({selectedMenus: []})
    this.dadosPessoais.current.clearState()
    this.props.form.resetFields()
    this.props.form.validateFields()
    this.props.onClose({
      reset: this.props.form.resetFields,
      user
    })
  }

  toggleLoading = callBack =>
    this.setState(prevState => ({ loading: !prevState.loading }), callBack)

  create = async values => {
    try {
      await post(values)
      this.toggleLoading(() => {
        this.beforeClose()
        message.success("Usuário criado com sucesso!")
      })
    } catch (error) {
      this.toggleLoading(() => message.error(error))
    }
  }

  update = async values => {
    try {
      await update(values)
      const user = await find(values.id)
      this.toggleLoading(() => {
        this.beforeClose(user)
        message.success("Usuário atualizado com sucesso!")
      })
    } catch (error) {
      this.toggleLoading(() => message.error(error))
    }
  }

  handleSubmit = event => {
    event.preventDefault()
    this.props.form.validateFieldsAndScroll((error, values) => {
      if (!error) {
        this.toggleLoading(() => {
          this.props.user.id
            ? this.update({ ...values, id: this.props.user.id, menu: this.state.selectedMenus })
            : this.create({ ...values, menu: this.state.selectedMenus })
        })
      }
    })
  }

  menuSelectChange = value => {
    this.setState({ selectedMenus: value, selectedMenusChanged: true })
    this.props.form.validateFields()
  }

  render() {
    const { isOpen, form, user } = this.props
    const { loading, selectedMenus, selectedMenusChanged } = this.state

    return (
      <Drawer
        title="&nbsp;"
        width={700}
        onClose={() => this.beforeClose()}
        visible={isOpen}
      >
        <Form layout="vertical" onSubmit={this.handleSubmit}>
          <DadosPessoais user={user} form={form} ref={this.dadosPessoais} />
          <Typography.Title>Acesso</Typography.Title>

          <Select
            value={ selectedMenus && selectedMenus.length > 0 ? selectedMenus : (user.menu && user.menu.length > 0 ? user.menu : []) }
            mode="multiple"
            placeholder="Selecione quais menus o usuário pode acessar"
            onChange={this.menuSelectChange}>
            { MenuFuncionarioEnum.map((option) =>
              <Select.Option key={option.value} value={option.value}>{option.text}</Select.Option>)
            }

          </Select>
          <Form.Item>
            <Row className="mt-10" gutter={14} type="flex" justify="end">
              <SubmitButton
                cssClass="save-driver-button"
                fieldsOutsideFormTouched={selectedMenusChanged}
                form={form}
                type="primary"
                loading={loading}
                text="Salvar"
              />
            </Row>
          </Form.Item>
        </Form>
      </Drawer>
    )
  }
}

UsuarioFormulario = Form.create()(UsuarioFormulario)

export default withAppInsightsTracking(UsuarioFormulario)
